import Parametros from 'Interface/Requisicao';
import VinculoEmpregaticio, {
  FinderCalculadoraTurnoverVinculosEmpregaticios,
  FinderVinculosEmpregaticios, RetornoVinculoEmpregaticio
} from 'Interface/VinculosEmpregaticios';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

export const tag = 'VinculosEmpregaticios';

const url = '/vinculos-empregaticios';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag, 'CalculadoraTurnoverVinculosEmpregaticios'],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarVinculosEmpregaticios: construtor.query<
        FinderVinculosEmpregaticios,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.vinculos
            ? [
                ...resultado.vinculos.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarCalculadoraTurnoverVinculosEmpregaticios: construtor.query<
        FinderCalculadoraTurnoverVinculosEmpregaticios,
        Parametros | void
      >({
        query: (params) => `${url}?finder=calculadoraTurnover&${paramsParaString(params)}`,
        providesTags: () => [{ type: tag, id: 'CalculadoraTurnoverVinculosEmpregaticios' }],
      }),
      recuperarVinculoEmpregaticio: construtor.query<
        RetornoVinculoEmpregaticio,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarVinculoEmpregaticio: construtor.mutation<
        VinculoEmpregaticio,
        Partial<VinculoEmpregaticio>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: dados,
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarVinculoEmpregaticio: construtor.mutation<
        VinculoEmpregaticio,
        Partial<VinculoEmpregaticio> &
          Pick<VinculoEmpregaticio, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'PUT',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerVinculoEmpregaticio: construtor.mutation<
        VinculoEmpregaticio,
        Partial<VinculoEmpregaticio> & Pick<VinculoEmpregaticio, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'POST',
          body: formData(dados, 'DELETE'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarVinculosEmpregaticiosQuery,
  useRecuperarVinculoEmpregaticioQuery,
  useAdicionarVinculoEmpregaticioMutation,
  useEditarVinculoEmpregaticioMutation,
  useRemoverVinculoEmpregaticioMutation,
  useRecuperarCalculadoraTurnoverVinculosEmpregaticiosQuery,
} = apiExtendida;
